<template>
  <div class="followup-page">
    <div class="followup-card">
      <div class="followup-header">
        <h3>进一步确认</h3>
      </div>
      <div class="followup-body">
        <div class="followup-desc">请选择用于对标的基准指数</div>
        <div class="followup-options">
          <div v-for="(option, index) in followUpData?.options" :key="index"
               :class="['followup-option', { active: selected === index }]" @click="selected = index">
            <span class="option-radio">{{ selected === index ? '●' : '○' }}</span>
            <span>{{ option.text }}</span>
          </div>
        </div>
      </div>
      <div class="followup-footer">
        <button class="btn-cancel" @click="handleCancel">取消</button>
        <button class="btn-confirm" :disabled="selected === null" @click="handleConfirm">确认</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FollowUp',
  data () {
    return {
      followUpData: null,
      selected: null,
      syncing: false
    }
  },
  created () {
    const data = localStorage.getItem('followUpData')
    if (data) {
      try {
        this.followUpData = JSON.parse(data)
        // 缓存选中选项的文本，供后续页面使用
        const savedIndex = localStorage.getItem('followUpSelected')
        if (savedIndex !== null && this.followUpData && this.followUpData.options) {
          const idx = parseInt(savedIndex, 10)
          const option = this.followUpData.options[idx]
          if (option) {
            localStorage.setItem('followUpOptions', option.text)
          }
        }
      } catch (e) {
        this.followUpData = null
      }
    }
    // 清除已处理标记，确保本次返回 Ceping 后能正常触发处理
    localStorage.removeItem('followUpProcessed')
    // 恢复副屏已选中的选项
    const saved = localStorage.getItem('followUpSelected')
    if (saved !== null) {
      this.selected = parseInt(saved, 10)
    }
    if (!this.followUpData) {
      this.$router.replace({ name: 'Ceping' })
    }
  },
  mounted () {
    window.addEventListener('storage', this.handleStorageChange)
  },
  beforeDestroy () {
    window.removeEventListener('storage', this.handleStorageChange)
  },
  watch: {
    selected (val) {
      if (this.syncing || val === null) return
      localStorage.setItem('followUpSelected', String(val))
      // 同步更新选中选项文本
      const option = this.followUpData?.options?.[val]
      if (option) localStorage.setItem('followUpOptions', option.text)
    }
  },
  methods: {
    handleStorageChange (event) {
      if (event.key === 'followUpSelected') {
        this.syncing = true
        this.selected = event.newValue !== null ? parseInt(event.newValue, 10) : null
        // 副屏同步时更新选中选项文本
        if (this.selected !== null) {
          const option = this.followUpData?.options?.[this.selected]
          if (option) localStorage.setItem('followUpOptions', option.text)
        }
        this.$nextTick(() => { this.syncing = false })
      }
    },
    handleConfirm () {
      if (this.selected === null) return
      localStorage.setItem('followUpSelected', String(this.selected))
      this.$router.push({ name: 'Ceping' })
    },
    handleCancel () {
      localStorage.removeItem('followUpData')
      localStorage.setItem('followUpSelected', 'cancel')
      this.$router.push({ name: 'Ceping' })
    }
  }
}
</script>

<style scoped>
.followup-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  /* background: linear-gradient(135deg, #f0f4ff 0%, #e8f0ff 50%, #f5f0ff 100%); */
  background: url('../../assets/bg-hp.png') no-repeat;
  background-size: 100% 100%;
  padding: 20px;
}

.followup-card {
  width: 90%;
  max-width: 420px;
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(99, 102, 241, 0.2);
}

.followup-header {
  padding: 20px 24px;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
}

.followup-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: white;
}

.followup-body {
  padding: 24px;
}

.followup-desc {
  font-size: 14px;
  color: #64748b;
  line-height: 1.5;
  margin-bottom: 16px;
  padding: 10px 14px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 8px;
  border-left: 3px solid #6366f1;
}

.followup-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.followup-option {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.followup-option:hover {
  border-color: #cbd5e1;
  background: #f8fafc;
}

.followup-option.active {
  border-color: #6366f1;
  background: #e0e7ff;
}

.option-radio {
  font-size: 18px;
  color: #94a3b8;
  font-weight: 300;
}

.followup-option.active .option-radio {
  color: #6366f1;
  font-weight: 700;
}

.followup-option span:last-child {
  font-size: 14px;
  color: #1e293b;
  flex: 1;
}

.followup-option.active span:last-child {
  color: #6366f1;
  font-weight: 500;
}

.followup-footer {
  display: flex;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #f1f5f9;
}

.btn-cancel,
.btn-confirm {
  flex: 1;
  padding: 12px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
}

.btn-cancel {
  background: #f1f5f9;
  color: #64748b;
}

.btn-cancel:hover {
  background: #e2e8f0;
}

.btn-confirm {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  color: white;
}

.btn-confirm:hover:not(:disabled) {
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.4);
}

.btn-confirm:disabled {
  background: #cbd5e1;
  cursor: not-allowed;
}
</style>
